import { render, staticRenderFns } from "./CustomerCustomerAccessTable.vue?vue&type=template&id=4be48246"
import script from "./CustomerCustomerAccessTable.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerAccessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports